export default __webpack_public_path__ + "static/media/PpaLogo.43812339.svg";